import i18n, { t } from "i18next";
import { numberFormat } from "./locale";
import { tPositional } from "./i18n";

export const songNum = (sn?: number): string => {
  const snStr = sn ? numberFormat(i18n.language, sn) : "";
  return tPositional(t, "schedules.song %d", snStr);
};
